import { withInterstitial } from 'wanderu-component-page-loader';
import { ScrollToTopOnMount } from 'wanderu-hocs';

import { CHECKOUT_URL_SEGMENT } from './constants';

const CheckoutPage = withInterstitial(import('./pages/Checkout'), {
    onLoad(module, ...args) {
        module.onLoad(module, ...args);
    },
});

export default [
    {
        path: `/${CHECKOUT_URL_SEGMENT}/`,
        key: 'checkout',
        component: ScrollToTopOnMount(CheckoutPage),
    },
];
